<!-- bindValue/bindLabel : le modèle est une liste de noms de statuts (chaînes), comme ce que les
     écrans passent en entrée et envoient à l'API. Sans ça ng-select mélange objets et chaînes. -->
<ng-select [items]="statusList"
           bindValue="name" bindLabel="label"
           [(ngModel)]="selectedStatus" [ngModelOptions]="{standalone: true}"
           [multiple]="multiple"
           [disabled]="disabled" [loading]="loading"
           [placeholder]="placeholder"
           (change)="onChange($event)">

  <ng-template ng-label-tmp let-item="item">
      <div class="media">
          <span *ngIf="type == item.type"
                class="m-1 badge {{item.badge}}"
                style="cursor: pointer;"
                [ngStyle]="{'background-color': item.color}">
               <b>{{item.label}}</b>
         </span>
      </div>
  </ng-template>

  <ng-template ng-option-tmp let-item="item" let-index="index">
    <div class="media">

      <div class="media-body">
          <small *ngIf="type == item.type"
                class="m-1 badge {{item.badge}}"
                style="cursor: pointer;"
                [ngStyle]="{'background-color': item.color}">
               <b>{{item.label}}</b>
          </small>
      </div>
    </div>
  </ng-template>

</ng-select>
